<template>
  <v-menu
    ref="menu1"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
    dense
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        dense
        outlined
        hide-details="auto"
        v-model="dateRangeText"
        label="Date range"
        persistent-hint
        v-bind="attrs"
        clearable
        v-on="on"
        @click:clear="((date_range = []), clearfilter())"
      ></v-text-field>
    </template>
    <v-date-picker v-model="date_range" range></v-date-picker>
  </v-menu>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    date_range: [],
  }),

  mounted() {
    if (this.filterDatas.isrouteNewPage == false) {
      if (
        this.filterDatas.start &&
        (!this.filterDatas.end || this.filterDatas.end == '')
      ) {
        this.date_range = [this.filterDatas.start];
        this.$emit('start', this.filterDatas.start);
      }
      if (this.filterDatas.end) {
        this.$emit('start', this.filterDatas.start);
        this.$emit('end', this.filterDatas.end);

        this.date_range = [this.filterDatas.start, this.filterDatas.end];
      }
    }
  },
  methods: {
    clearfilter() {
      this.$emit('clearFilters', null);
    },
    emitInput() {
      if (this.date_range.length > 1) {
        if (
          new Date(this.date_range[1]).getTime() >
          new Date(this.date_range[0]).getTime()
        ) {
          this.$emit('start', this.date_range[0]);
          if (this.filterDatas.isrouteNewPage == false) {
            this.$store.commit('UPDATE_DATE_END_FILTER', this.date_range[1]);
            this.$store.commit('UPDATE_DATE_START_FILTER', this.date_range[0]);
          }
          this.$emit('end', this.date_range[1]);
        } else {
          this.$emit('start', this.date_range[1]);
          this.$emit('end', this.date_range[0]);
          if (this.filterDatas.isrouteNewPage == false) {
            this.$store.commit('UPDATE_DATE_END_FILTER', this.date_range[0]);
            this.$store.commit('UPDATE_DATE_START_FILTER', this.date_range[1]);
          }
        }
      } else {
        if (this.filterDatas.isrouteNewPage == false) {
          this.$store.commit('UPDATE_DATE_START_FILTER', this.date_range[0]);
        }
        this.$emit('start', this.date_range[0]);
      }
    },
  },
  computed: {
    ...mapState(['filterDatas']),
    dateRangeText() {
      return this.date_range.join(' ~ ');
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.date_range = [];
      },
      deep: true,
    },
    dateRangeText: {
      handler(val) {
        this.emitInput();
      },
      deep: true,
    },
  },
};
</script>
